module.exports = __webpack_public_path__ + "static/ogrod-roslinnosc-da2e649549429f40026bc2253b6aa4a2.jpg";